import React from "react";
import { Container } from "react-bootstrap";

function Privacy() {
  return (
    <Container fluid className="about-section">
      <Container>
        <h1 className="project-heading">Privacy <strong className="purple">Policy</strong></h1>
        <div style={{ textAlign: "left", color: "white", marginTop: "20px" }}>
          <p><strong>Ultimo aggiornamento:</strong> 18 Dicembre 2025</p>
    
          {/* SEZIONE ANALYTICS */}
          <h4>1. Analisi Web e Privacy (Vercel Web Analytics)</h4>
          <p>
            Per monitorare il traffico e capire come gli utenti interagiscono con i contenuti, 
            questo sito utilizza <strong>Vercel Web Analytics</strong>, di proprietà di Vercel, hosting del suddetto sito. 
            Questo servizio adotta un approccio "Privacy-First":
          </p>
          <ul>
            <li>
              <strong>Nessun Cookie:</strong> Non vengono utilizzati cookie per tracciare i visitatori.
            </li>
            <li>
              <strong>Hashing Anonimo:</strong> I visitatori sono identificati tramite un hash generato dalla richiesta, 
              che si resetta automaticamente ogni giorno per impedire il tracciamento persistente tra sessioni diverse.
            </li>
            <li>
              <strong>Esclusione Bot:</strong> Il traffico automatizzato viene filtrato tramite l'analisi dello User Agent.
            </li>
          </ul>
          <p>
            👉 <a 
                href="https://vercel.com/docs/analytics" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#cd5ff8", textDecoration: "none" }}
               >
               Documentazione ufficiale Vercel Analytics
            </a>
          </p>

          <br/>

          {/* SEZIONE SPEED INSIGHTS */}
          <h4>2. Prestazioni Tecniche (Vercel Speed Insights)</h4>
          <p>
            Utilizziamo <strong>Vercel Speed Insights</strong>, di proprietà di Vercel, hosting del suddetto sito, per analizzare le metriche di prestazione del sito basate sui{""}
            <strong> Core Web Vitals</strong>, al fine di ottimizzare l'esperienza di navigazione.
          </p>
          <p>
            I dati raccolti sono aggregati e includono:
          </p>
          <ul>
            <li>
              <strong>Metriche di Caricamento:</strong> Misurazioni tecniche come il <em>First Contentful Paint (FCP)</em>, 
              il <em>Largest Contentful Paint (LCP)</em> e il <em>Real Experience Score (RES)</em>.
            </li>
            <li>
              <strong>Dati Aggregati per Contesto:</strong> Le prestazioni vengono analizzate in base al <strong>tipo di dispositivo</strong> 
                 {" "}(Desktop o Mobile) e alla <strong>provenienza geografica</strong> (Paese) dell'utente.
            </li>
            <li>
              <strong>Statistiche Anonime:</strong> I dati vengono visualizzati tramite percentili (es. P75) e mappe geografiche di calore, 
              senza profilare il singolo individuo.
            </li>
          </ul>
           <p>
            👉 <a 
                href="https://vercel.com/docs/speed-insights" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#cd5ff8", textDecoration: "none" }}
               >
               Documentazione ufficiale Speed Insights
            </a>
          </p>

          <br/>

          {/* SEZIONE DATI PERSONALI */}
          <h4>3. Dati Personali</h4>
          <p>
            Il sito è conforme al GDPR: non utilizza di cookie e non raccoglie dati personali (Nome, Email, ecc.). 
          </p>
          <br />

          {/* SEZIONE CONTATTI */}
          <h4>4. Contatti</h4>
          <p>
            Per qualsiasi delucidazione, contattare il Proprietario del sito al seguente indirizzo email: <span className="purple">masterplaysita@gmail.com</span> ed indicare come oggetto: <span className="purple">Privacy Policy</span>.
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default Privacy;